module.exports = __webpack_public_path__ + "RobotoLight.5628729ebd665dc7b877.woff";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoLight.woff
// module id = ../../../../../src/fonts/RobotoLight.woff
// module chunks = 3